<template>
    <div>
        <el-dialog title="驳回申诉" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
            <el-input
                :rows="5"
                type="textarea"
                placeholder="请输入驳回原因"
                v-model="reason"
                maxlength="250"
                show-word-limit />
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="btnLoading" @click="confirm">确认</el-button>
                <el-button @click="handleClose">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { BUSINESS_TYPE, YES_OR_NO, PERFORM_STATUS, ACTION_TYPE } from '../../constant.js'
import { updateSupplierLegalPersonPerformanceStatus } from '../../../../api/performManage.js'
export default {
    name: 'rejectAppeal',
    props: {},
    data() {
        return {
            reason: '',
            dialogVisible: false,
            btnLoading: false,
            id: '',
        }
    },
    methods: {
        init(id){
            this.dialogVisible = true
            this.id = id
        },
        handleClose() {
            this.reason = ''
            this.dialogVisible = false
        },
        confirm() {
            if (!this.reason.trim()) {
                return this.$message.warning('请输入驳回原因')
            }
            this.btnLoading = true
            updateSupplierLegalPersonPerformanceStatus({
                ids: [this.id],
                operativeFunction: ACTION_TYPE.APPEAL_REJECT,
                operativeFunctionReason: this.reason,
            })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('驳回成功')
                        this.$emit('refresh')
                        this.handleClose()
                    }
                })
                .finally(() => {
                    this.btnLoading = false
                })
        },
    },
}
</script>
<style lang="less" scoped>
</style>
